declare namespace $ {

	export class $shm_hitalama_map_page_arrow extends $mol_view {
		Line( ): $mol_view
		Head( ): $mol_view
		left_px( ): string
		top_px( ): string
		length_px( ): string
		transform( ): string
		from( ): readonly(number)[]
		to( ): readonly(number)[]
		kind( ): string
		sub( ): readonly(any)[]
		style( ): ({ 
			'left': ReturnType< $shm_hitalama_map_page_arrow['left_px'] >,
			'top': ReturnType< $shm_hitalama_map_page_arrow['top_px'] >,
			'width': ReturnType< $shm_hitalama_map_page_arrow['length_px'] >,
			'transform': ReturnType< $shm_hitalama_map_page_arrow['transform'] >,
		})  & ReturnType< $mol_view['style'] >
		attr( ): ({ 
			'shm_hitalama_map_page_arrow_kind': ReturnType< $shm_hitalama_map_page_arrow['kind'] >,
		})  & ReturnType< $mol_view['attr'] >
	}
	
}

//# sourceMappingURL=arrow.view.tree.d.ts.map